//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WxjsSdk from "@/Manager/10.Tms/ProductSnManager";
export default {
  props: ["controlItem"],
  data() {
    return {
      titleWidth: "60px",
      conText:''
    };
  },

  created() {},

  mounted() {
    this.wxJsSdks();
  },

  methods: {

    async doEvent(){

      var $e = this.$cmd.checkEvent(this.controlItem,"OnChange");
      if (!$e) return;

      var $cmd = $e.Cmd;
      if (!$cmd) return;

      var url = $cmd.CommandText;
      await this.$parent.$repostForm(url);
      return;

    },

    async onBlur(event) {
      console.log("onBlur---onBlur", event);
      this.doEvent();
    },

    onInput(value) {
      //console.log("onInput---value",value);
    },

    onScanClick() {
      //this.controlItem.ControlValue = "";
      this.$msg.info("启动扫一扫");
      var that = this;
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: function(res) {
          that.conText = res.resultStr; 
          that.controlItem.ControlValue = res.resultStr
        },
        fail: err => that.err_toast(err)
      });
    },

    onDeleteClick() {
      this.controlItem.ControlValue = "";
      this.$msg.info("清除成功");
    },

    wxJsSdks() {
      var wxUrl = window.location.href.split("#")[0];
      var sdkData = {
        uOpenId: "8659662804444e4b9ff929bb78b3da21",
        url: wxUrl
      };
      WxjsSdk.wxJsSdk(sdkData).then(res => {
        this.$msg.hideLoading();
        var config = wx.config({
          debug: false, // true,// 开启调试模式
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          // 必填，需要使用的JS接口列表
          jsApiList: ["scanQRCode"]
        });
        console.log(config, "config");
      });
    }
  }
};
